// extracted by mini-css-extract-plugin
export default {"wired":"qAlCAU","name":"iVCrVJ","mobile":"kaLvty","image":"KPvS5C","skeleton":"WJN0pu"};